const makeColor = (color) =>
  color
    // Parse WordPress-specific 'var:prefix|color|primary' syntax
    ?.replace(/^var:(.*)/, "var(--wp--$1)")
    ?.replace(/\|/g, "--")
    // Preserve strings that look like functions by prefixing them with a unique string.
    ?.replace(/^(.*[(])/, "##$1")
    // Assume non-hex values are preset colors, with the fallback being a CSS color name if not.
    ?.replace(/^([^#].*)/, "var(--wp--preset--color--$1, $1)")
    // Restore function-like colors so a 'normal value'.
    ?.replace(/^##/, "");

const getStyle = (block) =>
  block?.attributes?.style ? JSON.parse(block.attributes.style) : undefined;

export const backgroundColor = (block) =>
  makeColor(
    block?.attributes?.backgroundColor ??
      getStyle(block)?.color?.backgroundColor
  );

export const linkTextColor = (block) =>
  makeColor(getStyle(block)?.elements?.link?.color?.text);

export const textColor = (block) =>
  makeColor(block?.attributes?.textColor ?? getStyle(block)?.color?.textColor);
